
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TriIconRecord',
  props: {
    size: { type: String, default: '18px' },
    color: { type: String, default: 'currentColor' },
  },
})
